import { render, staticRenderFns } from "./transferPayable.vue?vue&type=template&id=0fd8b0b4&scoped=true&"
import script from "./transferPayable.vue?vue&type=script&lang=js&"
export * from "./transferPayable.vue?vue&type=script&lang=js&"
import style0 from "./transferPayable.vue?vue&type=style&index=0&id=0fd8b0b4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd8b0b4",
  null
  
)

export default component.exports